import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, processError } from "../../../core/helpers/service-helper";

export const obtenerInformeEmpleados = async (startDate, endDate) => {
    const data = { start_date: startDate, end_date: endDate };

    try {
        const response = await axios.post(
            `${API_URL}/cuadroTurnos/informe`,
            data,
            { headers: getHeaders() }
        );

        return response.data;
    } catch (error) {
        return processError(error);
    }
};

export const exportarRecargosHorasExtras = async (
    fecha_inicial,
    fecha_final,
    idSede = null
) => {
    try {
        const response = await axios.post(
            `${API_URL}/cuadroTurnos/exportarHorasRecargos`,
            {
                fecha_inicial: fecha_inicial,
                fecha_final: fecha_final,
                idSede: idSede,
            },
            { headers: getHeaders() }
        );

        return response.data;
    } catch (error) {
        return error.response.data;
    }
};
